import {APP_KEY , PHP_API_URL} from "../../../util/constants";

//获取用户列表
export function getRechargeListRequest(username,type,times,offset,limit,callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'get_school_teacher_chongzhi_xiaofei_list');
  formData.append("username", username);//(1:充值  2：消耗 不选传空字符串)
  formData.append("type", type);//(1:充值  2：消耗 不选传空字符串)
  formData.append("start_time", times[0]);
  formData.append("end_time", times[1]);
  formData.append("offset", offset);
  formData.append("limit", limit);

  return fetch(PHP_API_URL+'/Chongzhi_xiaofei/index',{
    method: 'post',
    body: formData,
  }).then(function (res) {
    return res.json();
  }).then(function (json) {
    callback && callback(json);
  }).catch(e => {
    console.error(e);
    callback && callback(e);

  });
}
export function rechargeRequest(username,jifen,beizhu,user_type,school_code,callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'chongzhi');
  formData.append("username",username);
  formData.append("jifen", jifen);
  formData.append("beizhu",beizhu);
  formData.append("user_type", user_type);
  formData.append("school_code", school_code);
  console.log('输出一下formData')
  console.log(formData);

  return fetch(PHP_API_URL+'/Chongzhi_xiaofei/index',{
    method: 'post',
    body: formData,
  }).then(function (res) {
    return res.json();
  }).then(function (json) {
    callback && callback(json);
  }).catch(e => {
    console.error(e);
    callback && callback(e);

  });
}